<template>
  <div ref="focusTarget" class="container question-range">
    <h2 class="question-title">{{ step.text }}</h2>
    <div class="question-checkbox">
      <div class="vuerange">
        <span class="vuerange__num vuerange__min">Lite</span>
        <vue-slider :contained="true" v-model="value" :tooltip="'always'" :min="0" :max="4">
          <template v-slot:tooltip="{ value, focus }">
            <div :class="['custom-tooltip', { focus }]">
              <div class="vuerange__dragger js--vuerange__dragger" :v-data="value">
                <div class="vuerange__inputWrapper">
                  <span class="vuerange__label">{{ optionText }}</span>
                </div>
                <div class="vuerange__icon">
                  <img :src="avatar != '' ? avatar.icon : defaultIcon" />
                </div>
              </div>
            </div>
          </template>
        </vue-slider>
        <span class="vuerange__num vuerange__max">Mye</span>
      </div>
    </div>

    <transition name="fader">
      <a href="#" @click="nextStep(50)" @touchstart.prevent="nextStep(50)" v-if="options[answer]" class="btn btn--red next-question">Neste steg</a>
    </transition>
  </div>
</template>

<script>
import steps from '../../appdata/steps.js'
import defIco from '../../assets/avatar.png'
import { mapFields } from 'vuex-map-fields'
import StepFunctions from '@/src/components/mixins/StepFunctions.js'
import VueSlider from 'vue-slider-component'

import 'vue-slider-component/theme/default.css'
export default {
  mixins: [StepFunctions],
  components: {
    VueSlider
  },
  mounted() {
    this.options = this.step.responses
    var answerIndex = this.answers.map(item => item.id).indexOf(this.stepKey)
    if (answerIndex > -1) {
      this.value = this.answers[answerIndex].value
    } else {
      this.value = 2
    }

    this.optionText = this.options[this.value].text
  },
  data() {
    return {
      value: 0,
      optionText: '',
      autoMove: false,
      defaultIcon: defIco,
      options: [],
      initialized: true
    }
  },

  watch: {
    value(newValue, oldValue) {
      if (this.initialized) {
        this.answer = newValue
        this.optionText = this.options[newValue].text
      } else {
        this.initialized = true
      }
    }
    // whenever question changes, this function will run
  },
  computed: {
    ...mapFields(['weight', 'avatar'])
  },
  methods: {
    nextStep(timeout = 3000) {
      setTimeout(() => {
        this.$eventBus.$emit('quiz-nav', 'next')
      }, timeout)
    },
    answerClass(id) {
      if (this.answer === null) {
        return ''
      }

      let answer = this.findAnswer(id)
      let answerPoints = this.answerPoints(id)

      if (this.answer == answer.value) {
        if (answerPoints > 0) {
          return 'correct'
        } else {
          return 'wrong'
        }
      } else {
        if (answerPoints > 0) {
          return 'correct'
        }
      }
    }
  }
}
</script>

<style lang="scss">
input.answer {
  display: none;
  + label {
    padding-left: 0px;
    position: relative;
    border: 2px solid #fff;
    display: block;
    text-align: center;
    cursor: pointer;
    margin: 20px 35px;
    font-size: 19.6px;
    padding: 10px;
    &:hover {
      background: #f04e23;
      border-color: #f04e23;
    }
    @media (max-width: 768px) {
      padding: 10px;
      margin: 14px 10px;
    }
  }
  &:checked + label {
    background: #f04e23;
    border-color: #f04e23;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/steps/TextRange.vue